import { parseTime } from '@/utils/ruoyi';

export const getSafeRedirectPath = (path = '/', defaultPath = '/') => {
  if (!path) return defaultPath;

  let redirectPath = path;
  try {
    redirectPath = decodeURIComponent(path);
  } catch {
    redirectPath = path;
  }

  return redirectPath.includes('?') ? defaultPath : redirectPath;
};

/**
 * 表格时间格式化
 */
export const formatDate = (cellValue: string) => {
  if (cellValue == null || cellValue == '') return '';
  const date = new Date(cellValue);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? `0${ date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${ date.getDate()}` : date.getDate();
  const hours = date.getHours() < 10 ? `0${ date.getHours()}` : date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${ date.getMinutes()}` : date.getMinutes();
  const seconds = date.getSeconds() < 10 ? `0${ date.getSeconds()}` : date.getSeconds();
  return `${year }-${ month }-${ day } ${ hours }:${ minutes }:${ seconds}`;
};

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export const formatTime = (time: string, option: string) => {
  let t: number;
  if ((`${ time}`).length === 10) {
    t = parseInt(time) * 1000;
  } else {
    t = +time;
  }
  const d: any = new Date(t);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60) }分钟前`;
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600) }小时前`;
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(t, option);
  } else {
    return `${d.getMonth() + 1 }月${ d.getDate() }日${ d.getHours() }时${ d.getMinutes() }分`;
  }
};

/**
 * @param {string} url
 * @returns {Object}
 */
export const getQueryObject = (url: string) => {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj: { [key: string]: string } = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
};

/**
 * @param {string} input value
 * @returns {number} output value
 */
export const byteLength = (str: string) => {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (let i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
};

/**
 * @param {Array} actual
 * @returns {Array}
 */
export const cleanArray = (actual: Array<any>) => {
  const newArray: any[] = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
};

/**
 * @param {Object} json
 * @returns {Array}
 */
export const param = (json: any) => {
  if (!json) return '';
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return '';
      return `${encodeURIComponent(key) }=${ encodeURIComponent(json[key])}`;
    }),
  ).join('&');
};

/**
 * @param {string} url
 * @returns {Object}
 */
export const param2Obj = (url: string) => {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj: any = {};
  const searchArr = search.split('&');
  searchArr.forEach((v) => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
};

/**
 * @param {string} val
 * @returns {string}
 */
export const html2Text = (val: string) => {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
};

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export const objectMerge = (target: any, source: any | any[]) => {
  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
};

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export const toggleClass = (element: HTMLElement, className: string) => {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += `${ className}`;
  } else {
    classString = classString.substring(0, nameIndex) + classString.substring(nameIndex + className.length);
  }
  element.className = classString;
};

/**
 * @param {string} type
 * @returns {Date}
 */
export const getTime = (type: string) => {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
};

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export const debounce = (func: any, wait: number, immediate: boolean) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let result: any;

  return function (this: unknown, ...args: any[]) {
    const callNow = immediate && !timeout;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        result = func.apply(this, args);
      }
    }, wait);
    if (callNow) {
      result = func.apply(this, args);
    }
    return result;
  };
};

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export const deepClone = (source: any) => {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone' as any);
  }
  const targetObj: any = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
};

/**
 * @param {Array} arr
 * @returns {Array}
 */
export const uniqueArr = (arr: any) => {
  return Array.from(new Set(arr));
};

/**
 * @returns {string}
 */
export const createUniqueString = (): string => {
  const timestamp = `${+new Date() }`;
  const num = (1 + Math.random()) * 65536;
  const randomNum = parseInt(`${num }`);
  return (+(randomNum + timestamp)).toString(32);
};

/**
 * Check if an element has a class
 * @param ele
 * @param {string} cls
 * @returns {boolean}
 */
export const hasClass = (ele: HTMLElement, cls: string): boolean => {
  return !!ele.className.match(new RegExp(`(\\s|^)${ cls }(\\s|$)`));
};

/**
 * Add class to element
 * @param ele
 * @param {string} cls
 */
export const addClass = (ele: HTMLElement, cls: string) => {
  if (!hasClass(ele, cls)) ele.className += ` ${ cls}`;
};

/**
 * Remove class from element
 * @param ele
 * @param {string} cls
 */
export const removeClass = (ele: HTMLElement, cls: string) => {
  if (hasClass(ele, cls)) {
    const reg = new RegExp(`(\\s|^)${ cls }(\\s|$)`);
    ele.className = ele.className.replace(reg, ' ');
  }
};

/**
 * @param {string} path
 * @returns {Boolean}
 */
export const isExternal = (path: string) => {
  return /^(https?:|http?:|mailto:|tel:)/.test(path);
};

/**
 * 通用复制函数（兼容多浏览器）
 * @param text 要复制的文本
 * @returns 是否复制成功
 */
const copyToClipboard = async (text: string): Promise<boolean> => {
  // 优先使用现代 Clipboard API
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn('Clipboard API 失败，降级使用 execCommand：', err);
    }
  }

  // 降级方案：创建临时输入框
  const input = document.createElement('input');
  input.value = text;
  document.body.appendChild(input);
  input.select(); // 选中内容
  input.setSelectionRange(0, text.length); // 兼容移动设备

  try {
    const success = document.execCommand('copy');
    if (success) {
      return true;
    }
  } catch (err) {
    console.error('execCommand 复制失败：', err);
  } finally {
    document.body.removeChild(input); // 移除临时元素
  }
  return false;
};

// 使用示例
export const handleCopy = async (text) => {
  const success = await copyToClipboard(text);
  if (success) {
    ElMessage.success('复制成功！');
  } else {
    ElMessage.error('复制失败，请手动复制');
  }
};

/**
 * 图片下载通用工具
 * @param imgSrc 图片地址
 * @param fileName 自定义文件名
 * @param isCrossOrigin 是否跨域（自动检测/手动指定）
 */
export const downloadImage = async (imgSrc: string, fileName = '下载图片', isCrossOrigin = false) => {
  // 自动检测跨域（可选）
  if (!isCrossOrigin) {
    const currentDomain = window.location.hostname;
    const imgDomain = new URL(imgSrc).hostname;
    isCrossOrigin = currentDomain !== imgDomain;
  }

  if (isCrossOrigin) {
    // 跨域图片走 canvas 方案
    await new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.crossOrigin = 'anonymous'; // 关键：允许跨域
      img.src = imgSrc;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('Canvas 初始化失败'));
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error('Blob 创建失败'));
          downloadBlob(blob, fileName, 'png');
          resolve();
        });
      };
      img.onerror = () => reject(new Error('跨域图片加载失败'));
    });
  } else {
    // 同源图片走 fetch 方案
    const response = await fetch(imgSrc);
    const blob = await response.blob();
    const ext = blob.type.split('/')[1] || 'png';
    downloadBlob(blob, fileName, ext);
  }
};

// 辅助函数：下载 blob 文件
const downloadBlob = (blob: Blob, fileName: string, ext: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.${ext}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  ElMessage.success('下载成功！');
};
export function reliableImageLoad(url, crossOrigin = 'anonymous') {
  return new Promise((resolve, reject) => {
    // 1. 新建图片对象，强制清空缓存（关键）
    const img = new Image();
    // 2. 显式设置跨域（即使服务端配置了，前端也要加）
    img.crossOrigin = crossOrigin;

    // 3. 绑定事件（先绑定，再设src）
    let loaded = false; // 防止重复触发
    img.onload = () => {
      if (loaded) return;
      loaded = true;
      resolve(img);
    };
    img.onerror = (err) => {
      if (loaded) return;
      loaded = true;
      reject(new Error(`图片加载失败：${url}，原因：${err.message}`));
    };
    // 兼容IE的onreadystatechange
    img.onreadystatechange = () => {
      if (loaded) return;
      if (img.readyState === 'complete' || img.readyState === 'loaded') {
        loaded = true;
        resolve(img);
      }
    };

    // 4. 处理缓存 + 强制重新请求（解决跨域缓存导致的onload不触发）
    // 给URL加随机参数，避免浏览器使用缓存的跨域图片
    const cacheBustUrl = `${url}${url.includes('?') ? '&' : '?'}cache_bust=${Date.now()}`;

    // 5. 最后设置src（必须在所有事件绑定后）
    img.src = cacheBustUrl;

    // 6. 兜底：超时检测（防止图片一直卡在加载中）
    setTimeout(() => {
      if (!loaded) {
        loaded = true;
        reject(new Error(`图片加载超时：${url}`));
      }
    }, 10000); // 10秒超时
  });
}
export async function downloadImageFromElement(img: HTMLImageElement, fileName: string = 'download-image'): Promise<void> {
  try {
    const imgUrl = img.src;
    const isCrossOrigin = img.crossOrigin === 'anonymous' || img.crossOrigin === 'use-credentials';

    let downloadUrl: string;

    if (isCrossOrigin) {
      // 跨域图片：先 fetch 转为 Blob
      const response = await fetch(imgUrl, { mode: 'cors' });
      if (!response.ok) throw new Error(`请求失败: ${response.status}`);

      const blob = await response.blob();
      downloadUrl = URL.createObjectURL(blob);
    } else {
      // 同域图片：直接使用原 URL
      downloadUrl = imgUrl;
    }

    // 创建隐藏 a 标签触发下载
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `${fileName}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // 释放 Blob URL 内存
    if (isCrossOrigin) URL.revokeObjectURL(downloadUrl);

    console.log('✅ 下载已触发');
  } catch (err) {
    console.error('❌ 下载失败:', err);
    alert('下载失败，请检查图片链接或跨域配置');
  }
}
